import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { VesselClassSurveyClientModel } from "../../../../../models/vessels/vessel.models";
import { UnitOfWorkObserver } from "../../../../../utilities/unit-of-work-observer";
import { ValidationController, ValidationRules } from "aurelia-validation";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { CustomValidationRenderer } from "../../../../../client-validation-system/custom-validation-renderer";
import { ValidationsClientService } from "../../../../../services/validations/validations-client.service";
import * as moment from "moment";

@autoinject
@transient()
export class AddClassSurveyDialog {

    public classSurvey: VesselClassSurveyClientModel = null;
    private vesselId: number;
    private id: number;
    private onComplete: (item: VesselClassSurveyClientModel, action: number) => void;

    private uow: UnitOfWorkObserver;

    constructor(private vesselSerive: ManageVesselService,
        private dialogClientService: DialogClientService,
        private bindingEngine: BindingEngine,
        private validationController: ValidationController,
        private notificationClientService: NotificationClientService,
        private validationsClientService: ValidationsClientService) {
        this.validationController.addRenderer(new CustomValidationRenderer());
    }

    protected activate(model: { onComplete: (item: VesselClassSurveyClientModel, action: number) => void, id: number, vesselId: number }) {
        this.id = model.id;
        this.vesselId = model.vesselId;
        this.onComplete = model.onComplete;
        if (this.id && this.id > 0)
            this.getItem(this.id);
        else this.initializeNew();
    }

    private getItem(id: number) {
        this.vesselSerive.getClassSurvey(id).then(x => {
            this.classSurvey = x;

            this.uow = new UnitOfWorkObserver(this.bindingEngine, this.classSurvey);

            this.uow.startTracking();

            this.addValidationRules();
        });
    }

    private initializeNew() {
        const item: VesselClassSurveyClientModel = {
            vesselClassSurveyId: null,
            classificationSocietyId: null,
            classificationSociety: null,
            description: null,
            lastInspected: null,
            dueDate: null,
            dueDateRangeFrom: null,
            dueDateRangeTo: null,
            postponedUntilDate: null,
            createdDate: null,
            vesselId: null
        };

        this.classSurvey = item;

        this.uow = new UnitOfWorkObserver(this.bindingEngine, this.classSurvey);

        this.uow.startTracking();

        this.addValidationRules();

        setTimeout(() => {
            this.classSurvey.vesselId = Number(this.vesselId);
            this.classSurvey.createdDate = new Date();
        });
    }

    private addValidationRules() {
        ValidationRules
            .ensure<VesselClassSurveyClientModel, any>(x => x.classificationSocietyId)
            .displayName('Class')
            .required()
            .ensure(x => x.dueDateRangeFrom)
            .satisfies((date, item) => moment(date).isSameOrBefore(item.dueDateRangeTo))
            .withMessage("Due date from must be before due date to")
            .when(x => x.dueDateRangeTo != null && x.dueDateRangeFrom != null)
            .ensure(x => x.dueDateRangeTo)
            .satisfies((date, item) => moment(date).isSameOrAfter(item.dueDateRangeFrom))
            .withMessage("Due date to must be after due date from")
            .when(x => x.dueDateRangeTo != null && x.dueDateRangeFrom != null)
            .on(this.classSurvey);
    }

    public async save() {
        const validationResponse = await this.validationController.validate();
        if (validationResponse.valid) {
            try {
                const response = await this.vesselSerive.saveClassSurvey({
                    changes: this.uow.getChanges(),
                    id: this.id
                });
                if (response.validationResult && response.validationResult.hasError) {
                    this.validationsClientService.showValidationErrors(response.validationResult);
                }
                else {
                    if (this.onComplete) {
                        this.onComplete(response.item, response.action);
                    }
                    this.dialogClientService.hide();
                }
            } catch (exception) {
                if (exception.validationResult && exception.validationResult.hasError) {
                    this.validationsClientService.showValidationErrors(exception.validationResult);
                }
            }
        } else {
            this.notificationClientService.show("Validation Error", validationResponse.results.map(x => x.message).join("<br>"), NotificationType.Error);
        }
    }

    cancel() {
        this.dialogClientService.hide();
    }

    public detached() {
        if (this.uow) {
            this.uow.dispose();
            this.uow = null;
        }
    }
}